import CookieService from './CookieService';
import {
  DEFAULT_LANGUAGE,
  LanguageCode,
  isSupportedLanguage,
  mapBrowserLanguage,
} from '../i18n/languages';

export const LANGUAGE_COOKIE = 'mypage_lang';

const LanguageService = {
  resolve: (): LanguageCode => {
    const cookie = CookieService.get(LANGUAGE_COOKIE);
    if (isSupportedLanguage(cookie)) return cookie.toLowerCase() as LanguageCode;

    const browser = mapBrowserLanguage(navigator.language);
    if (browser) return browser;

    return DEFAULT_LANGUAGE;
  },

  set: (code: LanguageCode): void => {
    CookieService.set(LANGUAGE_COOKIE, code);
  },

  getStored: (): string | null => CookieService.get(LANGUAGE_COOKIE),
};

export default LanguageService;
